import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * `languageChooserWidget` is a widget used to choose a language.
 *
 * @param {language} spec.currentLanguage - Language selected by default
 */
export default class LanguageChooserWidget extends Widget {
	constructor({ currentLanguage, service }) {
		super(...arguments);
		this._currentLanguage = currentLanguage;
		this._createEvents("onUpdateLanguage");
		this._service = service;
	}

	setLanguage(language) {
		this._currentLanguage = language;
		this.update();
	}

	renderContentOn(html) {
		html.div(
			{ class: "section" },
			html.ul(
				{ class: "language-list" },
				this._service
					.visibleLocales()
					.map((locale) => this._languageOptionRenderer(locale)),
			),
		);
	}

	_languageOptionRenderer(locale) {
		return (html) => {
			html.li(
				{
					"data-test": "language",
					class: [
						"lang",
						{ active: this._currentLanguage === locale.getCode() },
					],
				},
				html.i({ class: `lang-${locale.getFlagCssClass()}` }),
				html.a(locale.getName()),
			).click(() => {
				this._currentLanguage = locale.getCode();
				this.onUpdateLanguage.trigger(locale.getCode());
				this.update();
			});
		};
	}
}
